import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main className="pt-24" data-id="element-224">
      <About data-id="element-225" />
    </main>;
}